import { render } from "./customerlist.vue?vue&type=template&id=3c580381"
import script from "./customerlist.vue?vue&type=script&lang=js"
export * from "./customerlist.vue?vue&type=script&lang=js"

import "./customerlist.vue?vue&type=style&index=0&id=3c580381&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__